<template>
  <el-cascader
    v-model="val"
    :disabled="disabled"
    :options="localOptions"
    :clearable="clearable"
    :size="size"
    :props="props"
    @change="changeHandle"
    @visible-change="visibleChange"
  ></el-cascader>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'
import { getAYDictByTableCodeApi } from "@/util/api";

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  mixins: [emitter],
  props: {
    value: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'small'
    },
    options: {
      type: Array
    },
    checkStrictly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      val: this.value,
      localOptions: this.options,
      props: {
        lazy: true,
        checkStrictly: this.checkStrictly,
        lazyLoad (node, resolve) {
          getAYDictByTableCodeApi({
            valueParentId: node.data ? node.data.valueParentId : '',
            tableCode: "city",
          }).then(res => {
            if (res.msgCode == 200) {
              let nodes = res.responseData.map(item => ({
                value: item.valueCode,
                label: item.valueName,
                leaf: node.level >= 2, // 3层级
                valueParentId: item.valueCode
              }));
              resolve(nodes)
            }
          });
        }
      }
    }
  },
  watch: {
    value: {
      deep: true,
      handler: function(value) {
        if (value && Array.isArray(value)) {
          this.val = value || [];
        }
      }
    },
    options: {
      deep: true,
      immediate: true,
      handler: function (value) {
        if (this.localOptions && this.localOptions.length == 1) {
          this.localOptions = value;
          this.$forceUpdate()
        }
      }
    }
  },
  methods: {
    visibleChange () {
      if (this.localOptions && this.localOptions.length == 1) {
        this.localOptions = [];
      }
    },
    changeHandle (val) {
      let localArray = val;
      if (val && val.length == 1) {
        localArray.push(null);
        localArray.push(null);
      } else if (val && val.length == 2) {
        localArray.push(null);
      }
      this.dispatch('ElFormItem', 'el.form.change', localArray);
      this.$emit('change', localArray);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/business/LocationCascader.vue